// No navegador: abre o endereço numa aba nova (o navegador mostra ou baixa o arquivo).
export const extDoTipo = (mime?: string) => (mime ? (mime.split('/')[1] || '').replace(/[^a-z0-9]/gi, '').slice(0, 5) : '');
export async function abrirComApp(uri: string, _mime?: string, _nome?: string) {
  window.open(uri, '_blank', 'noopener');
}
export async function compartilharArquivo(uri: string, _mime?: string, _nome?: string) { window.open(uri, '_blank', 'noopener'); }
/** Texto 24 (2): arquivo do servidor (Escritório, pasta do grupo, conversas) abre como em Estudos: o app baixa uma cópia
 *  e mostra numa aba própria (PDF e imagem) — sem o endereço do servidor e com o nome certo. Outros tipos baixam com o nome certo. */
const nomeLimpo = (n?: string) => { const x = String(n || 'arquivo'); try { return /%[0-9a-f]{2}/i.test(x) ? decodeURIComponent(x) : x; } catch { return x; } };
export async function abrirUrlComApp(url: string, mime?: string, nome?: string) {
  const r = await fetch(url);
  if (!r.ok) throw new Error('HTTP ' + r.status);
  const tipo0 = mime || r.headers.get('content-type') || '';
  const tipo = tipo0 === 'application/pdf' ? 'application/pdf' : /^image\/(png|jpe?g|gif|webp|heic|bmp)$/i.test(tipo0) ? tipo0 : /xml|text|json|csv/i.test(tipo0) ? 'text/plain;charset=utf-8' : 'application/octet-stream';
  const b = new Blob([await r.arrayBuffer()], { type: tipo });
  const u = URL.createObjectURL(b);
  const n = nomeLimpo(nome);
  const baixar = () => { const l = document.createElement('a'); l.href = u; l.download = n; document.body.appendChild(l); l.click(); l.remove(); };
  if (tipo.startsWith('image/')) {
    const w = window.open();
    if (!w) baixar();
    else { w.document.title = n; const img = w.document.createElement('img'); img.src = u; img.style.maxWidth = '100%'; w.document.body.appendChild(img); }
  } else if (tipo === 'application/pdf' || tipo.startsWith('text/')) {
    if (!window.open(u, '_blank', 'noopener')) baixar();
  } else baixar();
  setTimeout(() => URL.revokeObjectURL(u), 120000);
}
